export class Accordion
{
	constructor() {

		document.querySelectorAll('.accordion-section')?.forEach(elem => {
			elem.querySelector('.accordion-toggle').addEventListener('click',
				(e) => {
					e.preventDefault();
					const toggleElement = e.target as HTMLElement;
					toggleElement.closest('.accordion-section').classList.toggle('open');
				});
		});

	}
}